import { RefObject, useEffect } from 'react'
import { MapRef } from 'react-map-gl'
import { AutocompleteItem } from 'interfaces/algolia'

interface PopupHandlerProps {
  geoJson: GeoJSON.FeatureCollection<GeoJSON.Point, AutocompleteItem>
  selectedEventId: number | null | undefined
  setPopupInfo: (
    info: GeoJSON.Feature<GeoJSON.Point, AutocompleteItem> | null
  ) => void
  mapRef: RefObject<MapRef | null>
}

const isPointOnScreen =
  (map: MapRef | null) => (longitude: number, latitude: number) => {
    if (!map) return false

    const { x, y } = map.project([longitude, latitude])

    const rect = map.getCanvas().getBoundingClientRect()

    const pointYInPage = y + rect.top + window.scrollY
    const pointXInPage = x + rect.left + window.scrollX

    return (
      pointYInPage >= window.scrollY &&
      pointYInPage <= window.scrollY + window.innerHeight &&
      pointXInPage >= window.scrollX &&
      pointXInPage <= window.scrollX + window.innerWidth
    )
  }

export const usePopupHandler = ({
  geoJson,
  selectedEventId,
  setPopupInfo,
  mapRef
}: PopupHandlerProps) => {
  useEffect(() => {
    if (selectedEventId) {
      const feature =
        geoJson.features.find(
          (feature) => Number(feature.id) === selectedEventId
        ) ?? null

      if (
        feature &&
        isPointOnScreen(mapRef.current)(
          feature.geometry.coordinates[0]!,
          feature.geometry.coordinates[1]!
        )
      ) {
        setPopupInfo(feature)
      }
    } else {
      setPopupInfo(null)
    }
  }, [selectedEventId, geoJson, mapRef])
}
